import { BaseProductApi } from '@inter-ikea-storageone/range';
export class EketProductApi extends BaseProductApi {
    /**
     *
     * @override
     */
    getDefaultLeg() {
        return '70340044';
    }
}
//# sourceMappingURL=EketProductApi.js.map